import React from 'react';
import Headicon from '../../../../asset/headicon.png';
import '../../../../app/home/section/aboutcookapp/aboutcookapp.css'
import Faq from "react-faq-component";
import Userapp from '../../../../asset/userapp.png'

const Aboutcookapp = () => {

  const data = {
    // title: "FAQ (How it works)",
    rows: [
      {
        title: "Vendors invite,",
        content: `Welcome to our advanced e-commerce site, where convenience meets purchasing! We are happy to provide a 
        simplified online purchasing experience that will meet all of your needs. We've got you covered if you're looking 
        for the most recent food delivery, plants, and nursery, pick-up and drop-off service, home service.`,
      },

    ],
  };

  const styles = {
    bgColor: 'white',
    // titleTextColor: "#4d4d4d",
    // rowTitleColor: "4d4d4d",
    // rowContentColor: 'grey',
    arrowColor: "#028149",
    transitionDuration: ".5s",
    timingFunc: "ease",
    rowTitleTextSize: '20px',

  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true
  };


  return (
    <div className={'cookapp'}>
      <div className={'pad'}>
        <div className={'row'}>
          <div >

          </div>
          <div className={'col-lg-7 mt-3'}>
            <div className={'cl-lg-12 headicon'}>
              <img src={Headicon} />
              <h1 className={'mt-3'}>About <span>Homee Cook App</span></h1>
            </div>
            <div>
              {/* <Faq
                data={data}
                styles={styles}
                config={config}
                className={'faq'}

              /> */}
              <p>
                We are excited to invite you to join our growing community of talented
                chefs and restaurants on HOMEE. Our platform is designed to connect food lovers with top-rated
                chefs and restaurants in their area, providing a convenient and hassle-free way to enjoy delicious and
                healthy meals from the comfort of their own home.
                <br /><br />
                As a chef, we know that you're passionate about creating flavorful and unique dishes that delight your
                customers. We believe that your talent and creativity deserve to be showcased on our platform, and
                we'd love to partner with you to offer your dishes to our users.
                <br /><br />
                By partnering with HOMEE, you'll have access to a wider audience of food enthusiasts who are
                looking for quality meals that cater to their specific dietary needs and preferences. Our platform allows
                you to showcase your menu, manage your orders, and connect with your customers in a seamless
                and efficient way
                <br /><br />
                Joining our platform is simple and easy. All you have to do is create a profile and add your menu
                items, and you'll be ready to start receiving orders from our users. We handle the delivery and
                logistics, so you can focus on what you do best - creating delicious and healthy meals that your
                customers will love.
                <br /><br />
                If you're interested in joining our community of top-rated chefs and restaurants, please visit our
                website or contact us at [contact details] to learn more. We can't wait to showcase your talent on
                HOMEE.

              </p>
            </div>
          </div>
          <div className={'col-lg-5 px-5'}>
            <div>
              <img src={Userapp} width="100%" />
            </div>
          </div>
        </div>


      </div>
    </div>
  )
}

export default Aboutcookapp;